
// Updated ImageSlider.js to fetch from backend
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { get_imageslideruppermaster_active } from "./apis/matchmakingapi";
import { Spinner } from "react-bootstrap";
import { apiUrl } from "./coreservices/environment";

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", right: "10px" }}
      onClick={onClick}
    />
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", zIndex: 1, left: "10px" }}
      onClick={onClick}
    />
  );
};

const ImageSlider = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const response = await get_imageslideruppermaster_active();
      
      if (response && response.success && response.data) {
        setImages(response.data);
      } else {
        setError("Failed to load slider images");
        setImages([]);
      }
    } catch (error) {
      console.error("Error fetching slider images:", error);
      setError("Unable to load slider images");
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" size="sm" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5 text-danger">
        <small>{error}</small>
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="text-center py-5 text-muted">
        <small>No slider images available</small>
      </div>
    );
  }

  return (
    <div className="image-slider">
      <Slider {...settings}>
        {images.map((image) => (
          <div key={image._id}>
            {image.link ? (
              <a href={image.link} target="_blank" rel="noopener noreferrer">
                <img
                style={{width:'100%', height:'90vh', objectFit: "cover",}}
                  height={'90vh'}
                  src={`${apiUrl}${image.imagePath}`}
                  alt={image.altText || image.title}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/800x400?text=Image+Not+Found';
                  }}
                />
              </a>
            ) : (
              <img
              style={{width:'100%', height:'90vh', objectFit: "cover",}}
                  height={'90vh'}
                src={`${apiUrl}${image.imagePath}`}
                alt={image.altText || image.title}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/800x400?text=Image+Not+Found';
                }}
              />
            )}
            {(image.title || image.description) && (
              <div className="slider-caption">
                {image.title && <h3>{image.title}</h3>}
                {image.description && <p>{image.description}</p>}
              </div>
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;

// // src/ImageSlider.js
// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "./ImageSlider.css"; // Create this file for custom styles


// const NextArrow = (props) => {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block", right: "10px" }}
//       onClick={onClick}
//     />
//   );
// };

// const PrevArrow = (props) => {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block", zIndex: 1, left: "10px" }}
//       onClick={onClick}
//     />
//   );
// };
 

// const ImageSlider = ({ images }) => {
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     cssEase: "linear",
//     responsive: [
//       {
//         breakpoint: 1024, // For large screens
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 768, // For medium screens
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 480, // For small screens
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   // const ImageSlider = ({ images }) => {
//   //   const settings = {
//   //     dots: true,
//   //     infinite: true,
//   //     speed: 500,
//   //     slidesToShow: 1,
//   //     slidesToScroll: 1,
//   //     arrows: true,
//   //     // nextArrow: true,
//   //     // prevArrow: true,
//   //     // autoplay: true,
//   //     // autoplaySpeed: 2000,
//   //     cssEase: "linear",
//   //     responsive:
//   //   };

//   return (
//     <div className="image-slider">
//       <Slider {...settings}>
//         {images.map((image, index) => (
//           <div key={index}>
//             <img height={'50vh'} src={image} alt={`Slide ${index}`} />
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default ImageSlider;